export default __webpack_public_path__ + "static/coding_3-3f1c852ce4d1daff1f611d3c791d1f8c.svg";